// Orbiting integrations section copy (icons/brands stay in the component).
const orbitStack = {
  aria: 'Integrations that plug into the agent',
  eyebrow: 'Plugs into your stack',
  title: 'Connected to the tools you already run',
  lead:
    'Models, data stores, billing and infra, orchestrated together so the automation works with your existing systems instead of replacing them.',
};

export default orbitStack;
